module.exports = __webpack_public_path__ + "static/media/provider-awcmkm.c02ebef7.png";